import { component } from 'picoapp'

export default component((node) => {
    // edit and creation of addresses

    const addressOverview = node.querySelector('[data-address-overview]')

    const newAddress = node.querySelector('[data-new-address]')
    const openNewAddress = node.querySelector('[data-open-new-address]')

    const editAddress = node.querySelector('[data-edit-address]')
    const openEditedAddress = node.querySelectorAll('[data-open-edited-address]')

    const saveAddress = node.querySelectorAll('[data-save-new-address]')
    const cancelAddress = node.querySelectorAll('[data-cancel-new-address]')

    // active address being edited
    let activeEdit = null

    // open the edit form for the selected address
    if (openEditedAddress)
        openEditedAddress.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                if (e.target.hasAttribute('data-open-edited-address')) {
                    activeEdit = editAddress.querySelector(
                        `[data-address-id="${e.target.getAttribute('data-address-id')}"]`
                    )
                    addressOverview.style.display = 'none'
                    activeEdit.style.display = ''
                    editAddress.style.display = ''
                }
            })
        })

    // save edits to address
    if (saveAddress)
        saveAddress.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                if (elem.hasAttribute('data-new')) {
                    newAddress.querySelector('form').submit()
                } else {
                    activeEdit.querySelector('form').submit()
                }
            })
        })

    // abort editing/creating the address and clear inputs
    if (cancelAddress)
        cancelAddress.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                addressOverview.style.display = ''
                newAddress.style.display = 'none'
                editAddress.style.display = 'none'
                activeEdit.style.display = 'none'
                clearInputs(newAddress)
            })
        })

    // open the new address form
    if (openNewAddress)
        openNewAddress.addEventListener('click', (e) => {
            addressOverview.style.display = 'none'
            newAddress.style.display = 'block'
        })
})

// traverses down the DOM tree and clears all inputs
function clearInputs(parent) {
    parent.querySelectorAll('input').forEach((elem) => {
        elem.value = ''
    })
    parent.querySelectorAll('select').forEach((elem) => {
        if (elem.options[0]) elem.value = elem.options[0].value
    })
}
